.biel-search-button-content {
  cursor: pointer;
  max-width: fit-content;
}

.biel-search-button-content--rounded {
  display: none;
  align-items: center;
  background-color: var(--biel-search-button-bg-color);
  border-radius: var(--biel-search-button-border-radius);
  color: var(--biel-search-button-text-color);
  display: flex;
  padding: 8px;
  font-family: var(--biel-font-family);
  font-weight: var(--biel-search-button-text-font-weight);
  font-size: var(--biel-search-button-text-font-size);
  border: 1px solid var(--biel-search-button-border-color);
}

.biel-search-button-content--rounded slot {
  display: none;
}

.biel-search-button-content-icon {
  height: var(--biel-search-button-icon-size);
  width: var(--biel-search-button-icon-size);
}

.biel-search-button-content-ctrl-k {
  display: none;
  margin-left: 12px;
  font-size: 12px;
}

@media (min-width: 768px) {

  .biel-search-button-content--rounded {
    padding: var(--biel-search-button-padding);
  }

  .biel-search-button-content--rounded slot {
    display: block;
  }

  .biel-search-button-content-ctrl-k {
    display: block;
  }

  .biel-search-button-content-icon {
    margin-right: 5px;
  }

}